document.addEventListener('DOMContentLoaded', function() {
    const markers = document.querySelectorAll('.bikeInfo__marker');
    let activeMarker = null;

    markers.forEach(marker => {
        marker.addEventListener('click', function(event) {
            event.stopPropagation();

            if (activeMarker && activeMarker !== marker) {
                activeMarker.classList.remove('active');
                activeMarker.querySelector('.bikeInfo__marker__info').style.display = 'none';
                activeMarker.querySelector('.bikeInfo__marker-icon').style.transform = 'rotate(0deg)';
            }
            const isActive = marker.classList.toggle('active');
            const infoBox = marker.querySelector('.bikeInfo__marker__info');
            const icon = marker.querySelector('.bikeInfo__marker-icon');

            if (isActive) {
                infoBox.style.display = 'block';
                icon.style.transform = 'rotate(45deg)';
                activeMarker = marker;
            } else {
                infoBox.style.display = 'none';
                icon.style.transform = 'rotate(0deg)';
                activeMarker = null;
            }
        });
    });

    document.querySelector('.bikeInfo').addEventListener('click', function(event) {
        if (activeMarker) {
            activeMarker.classList.remove('active');
            activeMarker.querySelector('.bikeInfo__marker__info').style.display = 'none';
            activeMarker.querySelector('.bikeInfo__marker-icon').style.transform = 'rotate(0deg)';
            activeMarker = null;
        }
    });

    const accordionHeaders = document.querySelectorAll('.bikeInfo__accordion-header');
    const accordionCloses = document.querySelectorAll('.bikeInfo__accordion-item_close');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const content = this.nextElementSibling;

            if (content.style.display === "block") {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        });
    });

    accordionCloses.forEach(close => {
        close.addEventListener('click', function(event) {
            event.stopPropagation();
            const content = this.closest('.bikeInfo__accordion-content');

            if (content) {
                content.style.display = "none";
            }
        });
    });

});